import { Box, Breadcrumbs, Button, Typography } from '@material-ui/core'
import React from 'react'
import { useTranslation } from 'react-i18next'
import { useSelector } from 'react-redux'
import { useHistory } from 'react-router'
import Page from '../../../components/page/page'
import PageCenterColumn from '../../../components/page/pageCenterColumn'
import PageHeader from '../../../components/page/pageHeader'
import { BreadcrumbLink } from '../../../components/shared/breadcrumbLink/breadcrumbLink'
import {
  selectActiveContract,
  selectActiveFlexibility,
  selectActiveTabAditionals,
  selectClientData,
  selectIsFetchingClientContractsError
} from '../../../redux/selectors/client.selectors'
import { selectCurrentPage } from '../../../redux/selectors/router.selector'
import { getLinkClientText } from '../../clients/client.helper'
import { PriceComponentsCard } from '../../priceComponents/components/priceComponentsCard/priceComponentsCard'

export const ContractsPriceComponentsPage: React.FC<{}> = () => {
  const [t] = useTranslation(['globalerisLibrary', 'clients', 'clientFile', 'enums'])
  const history = useHistory()

  const currentPage = useSelector(selectCurrentPage)
  const clientData = useSelector(selectClientData)
  const contractData = useSelector(selectActiveContract)
  const flexibilityData = useSelector(selectActiveFlexibility)
  const activeTable = useSelector(selectActiveTabAditionals)

  // const isFetchingContracts = useSelector(selectIsFetchingClientContracts)
  const fetchingContractsError = useSelector(selectIsFetchingClientContractsError)

  const handleClickBackButton = () => {
    history.goBack()
  }

  return (
    <Page fullWidth={true}>
      <PageHeader title="Ficha de Cliente">
        <Button
          variant="text"
          color="primary"
          // disabled={isFetchingClient}
          onClick={handleClickBackButton}
        >
          {t('clients:searchPage.buttons.back')}
        </Button>
      </PageHeader>
      <PageCenterColumn>
        <Box mb={1}>
          <Breadcrumbs separator=">" aria-label="breadcrumb">
            {clientData && (
              <BreadcrumbLink toPathName="/client/file" state={{ clientID: clientData?.id }}>
                {`${t('clientFile:components.additionalsTab.client')} ${getLinkClientText(
                  clientData
                )} -
                    ID ${clientData.documentID}`}
              </BreadcrumbLink>
            )}
            <Typography key="3" color="primary" variant="subtitle1">
              {t('clientFile:components.additionalsTab.contract')} {contractData?.contractCode}
            </Typography>
            {flexibilityData && (
              <Typography key="3" color="primary" variant="subtitle1">
                {t('clientFile:components.additionalsTab.flexibility')}{' '}
                {flexibilityData?.description}
              </Typography>
            )}
          </Breadcrumbs>
        </Box>
        <PriceComponentsCard
          style={{ marginBottom: '8px' }}
          contractId={contractData?.id}
          flexibilityId={flexibilityData?.id}
          onRetry={() => {}}
        />
      </PageCenterColumn>
    </Page>
  )
}
